export const fmt = (n) => '฿' + Number(n).toLocaleString('th-TH');
